import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { Button } from '../components/ui/button';
export function Login() {
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/select-client');
  };
  return <div className="min-h-screen flex items-center justify-center p-4" style={{
    backgroundColor: '#1A1F2E'
  }} data-id="element-640">
      <div className="bg-card w-full max-w-md rounded-lg shadow-xl p-8 md:p-10" data-id="element-641">
        <div className="text-center mb-8" data-id="element-642">
          <div className="flex flex-col leading-tight justify-center items-center mb-2" data-id="element-643">
            <span className="font-logo text-[32px] tracking-wide" style={{
            color: '#0187c3'
          }} data-id="element-644">
              Esclapon
            </span>
            <span className="font-logo text-[32px] tracking-wide" style={{
            color: '#0187c3'
          }} data-id="element-645">
              & Co.
            </span>
          </div>
          <p className="text-muted-foreground" data-id="element-646">Accedi alla piattaforma</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-5" data-id="element-647">
          <div className="space-y-2" data-id="element-648">
            <label htmlFor="email" className="text-sm font-medium text-foreground" data-id="element-649">
              Email
            </label>
            <input id="email" type="email" placeholder="nome@esclapon.it" className="w-full px-4 py-2.5 rounded-md border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-accent/50 transition-shadow" required data-id="element-650" />
          </div>

          <div className="space-y-2" data-id="element-651">
            <label htmlFor="password" className="text-sm font-medium text-foreground" data-id="element-652">
              Password
            </label>
            <input id="password" type="password" placeholder="••••••••" className="w-full px-4 py-2.5 rounded-md border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-accent/50 transition-shadow" required data-id="element-653" />
          </div>

          <Button type="submit" className="w-full rounded-full h-11 text-base" data-id="element-654">
            Accedi
          </Button>
        </form>

        <div className="my-6 flex items-center" data-id="element-655">
          <div className="flex-1 border-t border-border" data-id="element-656"></div>
          <span className="px-4 text-sm text-muted-foreground" data-id="element-657">oppure</span>
          <div className="flex-1 border-t border-border" data-id="element-658"></div>
        </div>

        <Button variant="outline" type="button" onClick={() => navigate('/select-client')} className="w-full rounded-full h-11 text-base border-border hover:bg-muted/50" data-id="element-659">
          <Shield className="h-4 w-4 mr-2" data-id="element-660" />
          Accedi con SSO aziendale
        </Button>

        <div className="mt-8 text-center" data-id="element-661">
          <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-id="element-662">
            Problemi di accesso? Contatta il supporto
          </a>
        </div>
      </div>
    </div>;
}